import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import globalSettingsBranches from '../../../../../../../stores/global-settings-branches';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';
import globalSettingsStores from '../../../../../../../stores/settings-stores';

export const deleteClassOperation = async (
  branchId: number,
  buildingId: number,
  classId: number,
  setClassId: (classId: number | null) => void,
) => {
  try {
    setClassId(classId);

    const res = await appApi.deleteClass(branchId, buildingId, classId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      globalSettingsStores.fetchSetting();
      setClassId(null);
      return;
    }
    if (res.data.ok) {
      const branchesData = await appApi.getBranches();
      globalSettingsBranches.branches = branchesData;
      globalSettingsStores.fetchSetting();
      toast.success('הכיתה נמחקה בהצלחה');
    }
    setClassId(null);
  } catch (e) {
    setClassId(null);
    console.error(
      `deleteClassOperation failed with the branchId: ${branchId}, buildingId: ${buildingId}, classId: ${classId}, and the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
